import WithSideBarAndNavBar from 'layouts/withSideBarAndNavBar/withSideBarAndNavBar';
import PaystubSendAndWrite from 'components/paystub/paystub-send-and-write';

const PaystubSendManagement = () => {
  return (
    <WithSideBarAndNavBar>
      <PaystubSendAndWrite />
    </WithSideBarAndNavBar>
  );
};

export default PaystubSendManagement;
